// previewBuilder.ts
import type { CalculateResponse } from '@/types';
import { STEM_SECTION_COPY, type PreviewSectionId, type StemKey } from './previewCopy';

function stemKey(dayMaster: string): StemKey {
  const v = (dayMaster || '').trim();
  const map: Record<string, StemKey> = {
    '갑':'갑','甲':'갑','을':'을','乙':'을','병':'병','丙':'병','정':'정','丁':'정',
    '무':'무','戊':'무','기':'기','己':'기','경':'경','庚':'경','신':'신','辛':'신',
    '임':'임','壬':'임','계':'계','癸':'계',
  };
  return map[v[0]] ?? '갑';
}

export type PreviewLine = { tag: 'Fact' | 'Insight' | 'Hook' | 'Lock'; text: string };

export function getSectionPreview(calc: CalculateResponse, section: PreviewSectionId): PreviewLine[] {
  const k = stemKey((calc as any).day_master);
  const base = STEM_SECTION_COPY[k][section];

  const dm = (calc as any).day_master ? `일간 ${(calc as any).day_master}` : null;
  const el = (calc as any).day_master_element ? `오행 ${(calc as any).day_master_element}` : null;
  const prefix = [dm, el].filter(Boolean).join(' · ');

  const fact = prefix ? `${prefix} — ${base.fact}` : base.fact;

  return [
    { tag: 'Fact', text: fact },
    { tag: 'Insight', text: base.insight },
    { tag: 'Hook', text: base.hook },
    { tag: 'Lock', text: '상세 근거/타이밍/실행 설계는 결제 후 전체 리포트에서 잠금 해제됩니다.' },
  ];
}
